<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Edit Client User</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Client:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <ClientAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchClient"
                :searchOn="'searched_clients'"
                @event-name="handleChildEvent"
              ></ClientAutocomplete>
            </div>
            <div class="vx-col sm:w-1/4 w-full">
              {{ prevClientName }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>First Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="first_name"
                v-model="clientUserDescription.first_name"
                v-validate="'required'"
                data-vv-as="First Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('first_name')"
              >{{ errors.first("first_name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="surname"
                v-model="clientUserDescription.surname"
                v-validate="'required'"
                data-vv-as="Surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first("surname") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Job Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="job_role"
                v-model="clientUserDescription.job_role"
                data-vv-as="Job Title"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Desk Phone:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="desk_phone"
                v-model="clientUserDescription.desk_phone"
                data-vv-as="Desk Phone"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Softphone:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="softphone"
                v-model="clientUserDescription.softphone"
                data-vv-as="Softphone"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Mobile No.:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="mobile_no"
                v-model="clientUserDescription.mobile_no"
                data-vv-as="Mobile No."
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Alternate Phone 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_1"
                v-model="clientUserDescription.alternate_phone_1"
                data-vv-as="Alternate Phone 1"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Alternate Phone 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_2"
                v-model="clientUserDescription.alternate_phone_2"
                data-vv-as="Alternate Phone 2"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>User Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                v-validate="'required'"
                required
                name="user_stat"
                label="user_status"
                :options="userStatusList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="clientUserDescription.selected_user_status"
                data-vv-as="User Role"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('user_stat')"
              >{{ errors.first("user_stat") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                v-validate="'required'"
                required
                name="selected_role"
                label="role"
                :options="clientRoleTypes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="clientUserDescription.selected_role"
                data-vv-as="User Role"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('selected_role')"
              >{{ errors.first("selected_role") }}</span
            >
          </div>
    
          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Manager:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="full_name"
                :options="clientManagers"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="clientUserDescription.selected_manager"
              />
            </div>
          </div> -->

          <vs-divider class="m-5" />

          <!-- Head Office -->
          <h5 class="mb-5">Login Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Email Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                v-model="clientUserDescription.email"
                name="email"
                v-validate="'required'"
                data-vv-as="Email Address"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('email')"
              >{{ errors.first("email") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Password:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
             <vs-checkbox
              v-model="check_box_selected"
              :vs-value="1"
            ></vs-checkbox>
              <!-- <vs-input
                type="password"
                class="w-full"
                name="password"
                v-model="clientUserDescription.password"
                v-validate="'required'"
                data-vv-as="Password"
              /> -->
            </div>
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import moduleClientUserManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data() {
    return {
                              abilities : null,

      prevClientName: null,
      companySearchComponentKey: 0,
      clientUserId: null,
      clientManagers: [],
      clientRoleTypes: [],
      clients: [],
      userStatusList: [],
      clientUserDescription: {
        first_name: null,
        surname: null,
        desk_phone: null,
        softphone: null,
        mobile_no: null,
        alternate_phone_1: null,
        alternate_phone_2: null,
        job_role: null,
        manager: null,
        email: null,
        client_id: null,
                password_reset:null,
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleClientUserManagement,
    ClientAutocomplete,
    moduleClientManagement
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    }); 
    if (!moduleClientUserManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUserManagement
      );
      moduleClientUserManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  },
  mounted() {
    this.getClientRoleTypes();
    this.getClientUserStatus()
    this.clientUserId = this.$route.params.userId;
    this.init();
  },
  methods: {
    init() {
      this.$store
        .dispatch("clientUsersManagement/fetchClientUser", this.clientUserId)
        .then(res => {
          this.clientUserDescription = res.data;
          var self = this;
          this.userStatusList.forEach(function(ele) {
            if (ele.id == self.clientUserDescription.user_status) {
              self.clientUserDescription.selected_user_status = ele;
            }
          });          
          if (this.clientUserDescription.client_id) {
            this.showClientName(this.clientUserDescription.client_id);
          }
          this.clientRoleTypes.forEach(function(ele) {
            if (ele.id == self.clientUserDescription.roles[0].id) {
              self.clientUserDescription.selected_role = ele;
            }
          });
          this.getClientManagers(this.clientUserDescription.client_id)
          this.clientManagers.forEach(function(ele) {
            if (ele.id == self.clientUserDescription.manager) {
              self.clientUserDescription.selected_manager =
                ele.first_name + " " + ele.surname;
            }
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    showClientName(clientId) {
      this.$store
        .dispatch("clientsManagement/fetchClient", clientId)
        .then(res => {
          if (res) {
            let response = res.data;
            this.prevClientName = response.company_name;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    handleChildEvent() {
this.clientManagers = []
      this.clients = moduleClientManagement.state.searched_clients;
      this.clientUserDescription.client_id = this.clients.id;
      this.getClientManagers(this.clientUserDescription.client_id)
      this.prevClientName = null

    },
    getClientUserStatus() {
      this.$store
        .dispatch("clientUsersManagement/getClientUserStatus")
        .then(res => {
          this.userStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    searchClient(inputValue) {
      return this.$store
        .dispatch("clientsManagement/searchClient", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].company_name
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    submitForm() {
            if(this.check_box_selected){
        this.clientUserDescription.password_reset = 'y'
      }else{
         this.clientUserDescription.password_reset = 'n'
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateClientUser();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    updateClientUser() {
                  this.$vs.loading();

      this.$store
        .dispatch(
          "clientUsersManagement/updateClientUser",
          this.clientUserDescription
        )
        .then(res => {
          let self = this
          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Client User Updated",
              text: "The user was updated successfully"
            });
            self.$router.push({ path: "/client-users" });

          }else{
            self.$vs.notify({
              color: "danger",
              title: "Client User",
              text: "Email Already Exists"
            });
            setTimeout(()=> { self.$router.go(0) }, 2000);

          }
          self.$vs.loading.close();


        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getClientRoleTypes() {
      this.$store
        .dispatch("clientUsersManagement/getClientRoleTypes")
        .then(res => {
          this.clientRoleTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getClientManagers(clientId) {
      this.$store
        .dispatch("clientUsersManagement/getClientManagers",clientId)
        .then(res => {
          this.clientManagers = res.data;
          this.clientManagers = this.clientManagers.filter(function(ele) {
            ele.full_name = ele.first_name + " " + ele.surname;
            return ele;
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
